<template>
  <div class="d-flex">
    <div class="ml-3 mr-3">
      <v-flex
        v-if="isLoading"
        justify-center
      >
        <u-loader />
      </v-flex>
      <div v-else>
        <v-card class="mb-4">
          <v-card-title>
            <h5 class="pl-2">
              Feiertagsregionen Importieren/Exportieren
            </h5>
          </v-card-title>
          <div>
            <PublicHolidayRegionImport @imported="handleSuccessfulAction" />
          </div>
        </v-card>
        <v-card class="mb-3 pl-4">
          <v-card-title>
            <h5>
              Feiertagsregionen Bearbeiten
            </h5>
          </v-card-title>
          <v-btn
            v-if="$IsUserInRole('AllgemeinerFeiertagskalenderAdministration')"
            class="float-right"
            color="success"
            flat
            title="Neue Feiertagsregion erfassen"
            @click="showModal('regionCreate')"
          >
            <i class="fas fa-plus mr-3" /> Erfassen
          </v-btn>
          <table class="w-100 calenderOverview ml-2 mt-4">
            <colgroup>
              <col style="width: 30%">
              <col style="width: 50%">
              <col style="width: 20%">
            </colgroup>
            <thead>
              <tr>
                <th>Titel</th>
                <th>Gültigkeitsbereich</th>
                <th>Aktion</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="region in existingRegions"
                :key="region.id"
              >
                <td class="custom-td">
                  {{ region.title }}
                </td>
                <td class="custom-td">
                  <b-button
                    class="m-1"
                    @click="
                      expandedRegionArea =
                        expandedRegionArea == region.id ? -1 : region.id
                    "
                  >
                    <i
                      v-if="region.id == expandedRegionArea"
                      class="fas fa-eye-slash mr-2"
                    />
                    <i
                      v-else
                      class="fas fa-eye mr-2"
                    />
                    {{
                      region.id == expandedRegionArea
                        ? "Ausblenden"
                        : "Einblenden"
                    }}
                  </b-button>
                  <b-collapse
                    :id="region.id.toString()"
                    :visible="region.id == expandedRegionArea"
                  >
                    <b-card>
                      <v-flex
                        v-if="isLoading"
                        justify-center
                      >
                        <u-loader />
                      </v-flex>

                      <div v-if="region.id == expandedRegionArea">
                        <div id="tree-overlay" />
                        <u-tree-view
                          :open-all="false"
                          :selectable="false"
                          :tree-view-items="locationOptionsMap.get(region.id)"
                          :value="region.locations.map((x) => x.path)"
                          class="mt-2"
                          item-key="path"
                        >
                          <template v-slot:prepend="{ item }">
                            <i
                              :class="getIcon(item)"
                              :style="{ scale: '1.8', color: getColor(item) }"
                            />
                          </template>
                        </u-tree-view>
                      </div>
                    </b-card>
                  </b-collapse>
                </td>
                <td class="custom-td">
                  <v-btn
                    v-if="
                      $IsUserInRole('AllgemeinerFeiertagskalenderAdministration')
                    "
                    class="pt-0"
                    color="#007bff"
                    dark
                    fab
                    small
                    title="Bearbeiten"
                    @click="
                      regionToEdit = region;
                      showModal('regionEdit');
                    "
                  >
                    <i class="fas fa-edit" />
                  </v-btn>
                  <v-btn
                    v-if="
                      $IsUserInRole('AllgemeinerFeiertagskalenderAdministration')
                    "
                    color="#e72b37"
                    dark
                    fab
                    small
                    title="Löschen"
                    @click="
                      regionToDelete = region;
                      showModal('regionDelete');
                    "
                  >
                    <i class="fas fa-trash" />
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </table>
        </v-card>
      </div>
    </div>

    <!-- Create new Region -->
    <b-modal
      id="regionCreate"
      ref="regionCreate"
      hide-footer
      no-fade
      size="lg"
      title="neue Feiertagsregion erstellen"
    >
      <PublicHolidayRegionCreate
        :location-options="locationOptions"
        @cancel="cancelAction"
        @created="handleSuccessfulAction"
      />
    </b-modal>
    <b-modal
      id="regionEdit"
      ref="regionEdit"
      hide-footer
      no-fade
      size="lg"
      title="Feiertagsregion bearbeiten"
    >
      <PublicHolidayRegionEdit
        :location-options="locationOptions"
        :region-to-edit="regionToEdit"
        @cancel="cancelAction"
        @updated="handleSuccessfulAction"
      />
    </b-modal>
    <b-modal
      id="regionDelete"
      ref="regionDelete"
      hide-footer
      no-fade
      size="lg"
      title="Feiertagsregion löschen"
    >
      <p>
        Sind sie sicher, dass sie diese Feiertagsregion unwiederruflich löschen
        wollen?
      </p>
      <div class="orw">
        <v-btn
          color="success"
          flat
          @click="deletePublicHolidayRegion"
        >
          Löschen
        </v-btn>
        <v-btn
          color="#e72b37"
          flat
          @click="cancelAction"
        >
          Abbrechen
        </v-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { ValidateTreeView } from "@/helpers/TreeViewHelperResourceCalendar.js";
import { GetLocationTree } from "@/services/minimum.wage.services/resourceCalendar.minimum.wage";
import {
  GetPublicHolidayRegions,
  DeletePublicHolidayRegion,
} from "@/services/minimum.wage.services/publicholidayRegions.minimum.wage";
import PublicHolidayRegionCreate from "./PublicHolidayRegionCreate.vue";
import PublicHolidayRegionImport from "./PublicHolidayRegionImport.vue";
import PublicHolidayRegionEdit from "./PublicHolidayRegionEdit.vue";
import UTreeView from "@/components/common/UTreeView.vue";

export default {
  components: {
    PublicHolidayRegionCreate,
    PublicHolidayRegionEdit,
    PublicHolidayRegionImport,
    UTreeView,
  },
  data() {
    return {
      isLoading: false,
      existingRegions: [],
      regionToEdit: {},
      locationOptions: [],
      locationOptionsMap: new Map(),
      regionToDelete: {},
      expandedRegionArea: -1,
    };
  },
  created() {
    this.LoadAllExistingRegions();
    this.GetAllLocationOptions();
  },
  methods: {
    LoadAllExistingRegions() {
      GetPublicHolidayRegions(
        (response) => {
          this.existingRegions = response;
          this.CreateLocationOptionMap();
        },
        (error) => {
          console.error(error);
        },
      );
    },
    GetAllLocationOptions() {
      this.isLoading = true;
      GetLocationTree(
        false,
        (response) => {
          const validatedTreeView = ValidateTreeView(response, true);
          this.locationOptions = validatedTreeView.treeItems;
          this.CreateLocationOptionMap();
          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    getIcon(node) {
      if (node.selected) {
        return "fas fa-check-square checkbox-right ml-2";
      } else {
        return "fas fa-minus-square checkbox-minus ml-2";
      }
    },
    getColor(node) {
      if (node.selected) {
        return "red";
      } else {
        return "grey";
      }
    },
    CreateLocationOptionMap() {
      if (!this.locationOptions || this.locationOptions.length == 0) {
        return;
      }
      this.existingRegions.forEach((region) => {
        let regionPaths = region.locations.map((x) => x.path);
        let locationOptionsForRegion = [];

        this.locationOptions.forEach((countryNode) => {
          if (regionPaths.includes(countryNode.path)) {
            countryNode.selected = true;
            this.setChildrenAsSelected(countryNode);
            locationOptionsForRegion.push(countryNode);
            return;
          }
          let emptrycountryNode = { ...countryNode, children: [] };
          if (countryNode.children && countryNode.children.length > 0) {
            countryNode.children.forEach((cantonNode) => {
              if (regionPaths.includes(cantonNode.path)) {
                cantonNode.selected = true;
                this.setChildrenAsSelected(cantonNode);
                emptrycountryNode.children.push(cantonNode);
                return;
              }
              let emptrycantonNode = { ...cantonNode, children: [] };
              if (cantonNode.children && cantonNode.children.length > 0) {
                cantonNode.children.forEach((districtNode) => {
                  if (regionPaths.includes(districtNode.path)) {
                    districtNode.selected = true;
                    this.setChildrenAsSelected(districtNode);
                    emptrycantonNode.children.push(districtNode);
                    return;
                  }
                  let emptrydistrictNode = { ...districtNode, children: [] };
                  if (
                    districtNode.children &&
                    districtNode.children.length > 0
                  ) {
                    districtNode.children.forEach((cityNode) => {
                      if (regionPaths.includes(cityNode.path)) {
                        cityNode.selected = true;
                        emptrydistrictNode.children.push(cityNode);
                      }
                    });
                  }
                  if (emptrydistrictNode.children.length > 0) {
                    emptrycantonNode.children.push(emptrydistrictNode);
                  }
                });
              }
              if (emptrycantonNode.children.length > 0) {
                emptrycountryNode.children.push(emptrycantonNode);
              }
            });
          }
          if (emptrycountryNode.children.length > 0) {
            locationOptionsForRegion.push(emptrycountryNode);
          }
        });

        this.locationOptionsMap.set(region.id, locationOptionsForRegion);
      });
    },
    setChildrenAsSelected(parentNode) {
      if (parentNode.children && parentNode.children.length > 0) {
        parentNode.children.forEach((child) => {
          child.selected = true;
          this.setChildrenAsSelected(child);
        });
      }
    },
    deletePublicHolidayRegion() {
      DeletePublicHolidayRegion(
        this.regionToDelete.id,
        () => {
          this.LoadAllExistingRegions();
          this.hideModal("regionDelete");
        },
        (error) => {
          console.error(error);
        },
      );
    },
    handleSuccessfulAction() {
      this.LoadAllExistingRegions();
      this.hideModal("regionCreate");
      this.hideModal("regionEdit");
      this.hideModal("regionDelete");
    },
    cancelAction() {
      this.hideModal("regionCreate");
      this.hideModal("regionEdit");
      this.hideModal("regionDelete");
    },
    hideModal(modalId) {
      this.$refs[modalId].hide();
    },
    showModal(modalId) {
      this.$refs[modalId].show();
    },
  },
};
</script>

<style scoped>
.calenderOverview td,
.calenderOverview th {
  vertical-align: top;
}
</style>
